import { forwardRef } from 'react';

import { Menu, MenuItem } from '@progress/kendo-react-layout';
import { Popup as KendoPopup } from '@progress/kendo-react-popup';
import _map from 'lodash/map';
import styled from 'styled-components';

import { PopupProps } from './PopupProps';

const MENU_STYLE = { display: 'inline-block' };

export const Popup = forwardRef<HTMLDivElement, PopupProps>(({ className, anchor, onSelect, isOpen, menuItems, offset, vertical = true }, ref) => {
  return (
    <div>
      <StyledPopup ref={ref} anchor={anchor} offset={offset} show={isOpen}>
        <Menu className={className} vertical={vertical} style={MENU_STYLE} onSelect={onSelect}>
          {_map(menuItems, (item: { text: string }) => (
            <MenuItem key={item.text} text={item.text} />
          ))}
        </Menu>
      </StyledPopup>
    </div>
  );
});

Popup.displayName = 'Popup';

const StyledPopup = styled(KendoPopup)`
  & .k-popup {
    border-color: var(--kendo-color-border, rgba(33, 37, 41, 0.13));
    color: var(--kendo-color-on-app-surface, #212529);
    background-color: var(--kendo-color-surface-alt, #ffffff);
    box-shadow: var(--kendo-elevation-4, 0px 6px 13px rgba(0, 0, 0, 0.125));
  }
  & .k-popup .k-menu:not(.k-context-menu) > .k-item:hover,
  & .k-popup .k-menu:not(.k-context-menu) > .k-item.k-hover {
    color: color-mix(in srgb, var(--kendo-color-on-app-surface, #212529) 90%, transparent);
  }

  & .k-popup .k-menu:not(.k-context-menu) > .k-item {
    padding: 0.25em;
    font-size: 12px;
    color: color-mix(in srgb, var(--kendo-color-on-app-surface, #212529) 70%, transparent);
  }

  & .k-popup .k-menu:not(.k-context-menu) > .k-item:active,
  & .k-popup .k-menu:not(.k-context-menu) > .k-item.k-active {
    color: color-mix(in srgb, var(--kendo-color-on-app-surface, #212529) 100%, transparent);
  }

  & .k-popup .k-menu:not(.k-context-menu) > .k-item:focus,
  & .k-popup .k-menu:not(.k-context-menu) > .k-item.k-focus {
    box-shadow: inset 0 0 0 3px color-mix(in srgb, var(--kendo-color-on-app-surface, #212529) 15%, transparent);
  }
`;
